import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16, IcoSearchSmall16 } from '@onefootprint/icons';
import { Command } from 'cmdk';
import { useTranslation } from 'react-i18next';
import IconButton from '../../../icon-button';
type ComboInputProps = {
  value?: string;
  onValueChange?: (value: string) => void;
  onErase?: () => void;
  size?: 'compact' | 'default';
};
const ComboInput = t0 => {
  const $ = _c(18);
  const {
    value,
    onValueChange,
    onErase
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.combo"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("ui", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("input-placeholder");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const placeholder = t2;
  let t3;
  if ($[3] !== onErase || $[4] !== onValueChange) {
    t3 = () => {
      if (onErase) {
        onErase();
      } else {
        if (onValueChange) {
          onValueChange("");
        }
      }
    };
    $[3] = onErase;
    $[4] = onValueChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleErase = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IcoSearchSmall16 color="tertiary" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onValueChange || $[8] !== placeholder || $[9] !== value) {
    t5 = <Command.Input className="[all:unset] w-full h-full flex-1 text-primary placeholder:text-tertiary" value={value} onValueChange={onValueChange} placeholder={placeholder} />;
    $[7] = onValueChange;
    $[8] = placeholder;
    $[9] = value;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== handleErase || $[12] !== t || $[13] !== value) {
    t6 = value && <IconButton aria-label={t("erase-search")} onClick={handleErase} size="compact" icon={IcoCloseSmall16} />;
    $[11] = handleErase;
    $[12] = t;
    $[13] = value;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="text-body-2 flex items-center justify-between gap-2 w-full p-3 sticky top-0 z-2 overflow-hidden bg-primary border-b border-solid border-b-tertiary">{t4}{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default ComboInput;